import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { HealthPage } from './HealthPage';

/** Screens of this feature (A3). */
export const routes: FeatureRoute[] = [
  {
    path: 'health',
    element: (
      <RequireCapability anyOf={['tenants.view']} what="system health">
        <HealthPage />
      </RequireCapability>
    ),
  },
];
